(function () {
  function initTouchHeader() {
    const header = document.getElementById('touchHeader');
    const toggle = document.getElementById('touchHeaderToggle');
    const drawer = document.getElementById('touchHeaderDrawer');

    if (!header || !toggle || !drawer) return;
    if (toggle.dataset.touchHeaderBound === 'true') return;

    toggle.dataset.touchHeaderBound = 'true';

    function shouldBeScrolledState() {
      return window.scrollY > 30;
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function updateHeaderState() {
      const isOpen = drawer.classList.contains('is-open');
      header.classList.toggle('is-scrolled', shouldBeScrolledState() || isOpen);
    }

    function handleScroll() {
      if (window.innerWidth <= 768 && drawer.classList.contains('is-open')) {
        closeDrawer();
      }

      updateHeaderState();
    }

    updateHeaderState();
    window.addEventListener('scroll', handleScroll, { passive: true });

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));

      updateHeaderState();
    });

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer();
        updateHeaderState();
      });
    });
  }

  initTouchHeader();

  document.addEventListener('shopify:section:load', initTouchHeader);
  document.addEventListener('shopify:section:reorder', initTouchHeader);
})();